/* eslint-disable import/order */
import { APAC_CHECKOUT_NAME, ApacCheckoutComponent } from "@apac/checkout";
import { APAC_FORM_UI_NAME, ApacFormUiComponent } from "@apac/core-form-ui";
import { APAC_UI_NAME, ApacUiComponent } from "@apac/ui";
import {
  CoreUiComponents,
  CORE_UI_NAME,
  CORE_FINTECH_UI_NAME,
  CoreFintechUiComponents,
  CORE_TRIPS_NAME,
  CoreTripsComponent,
  CORE_CHECKOUT_NAME,
  CoreCheckoutComponent,
  CORE_SELF_SERVE_NAME,
  CoreSelfServeComponent,
} from "@b2bportal/core-types";

import creditCardPaymentStyles from "./apac-checkout/CreditCardPayment/styles.module.scss";
import passengerRowStyles from "./apac-checkout/PassengerRow/PassengerRow.module.scss";

// Apac Ui
import travelCardsStyles from "./apac-ui/TravelerCards/TravelerCards.module.scss";
import locationAutocompleteSuggestionStyles from "./apac-ui/LocationAutoCompleteWithSuggestion/styles.module.scss";

// Core Trips Overrides
import tripsCardStyles from "./trips/TripsCard/styles.module.scss";
import tripsListStyles from "./trips/TripsList/styles.module.scss";
import tripsLoadingScreenStyles from "./trips/TripsLoadingScreen/styles.module.scss";

// Core UI Overrides
import pageOverrideStyles from "./core-ui/Page/styles.module.scss";
import pageHeaderOverrideStyles from "./core-ui/PageHeader/styles.module.scss";
import filterDialogStyles from "./core-ui/FilterDialogContainer/styles.module.scss";
import notificationBannerStyles from "./core-ui/NotificationBanner/styles.module.scss";
import dialogStyles from "./core-ui/Dialog/styles.module.scss";
import iframeDialogStyles from "./core-ui/IframeDialog/styles.module.scss";
import infoBannerStyles from "./core-ui/InfoBanner/styles.module.scss";
import drawerStyles from "./core-ui/Drawer/styles.module.scss";
import pillStyles from "./core-ui/styles/Pill.module.scss";
import inputContainerStyles from "./core-ui/styles/InputContainer.module.scss";
import locationAutoCompleteStyles from "./core-ui/styles/LocationAutocomplete.module.scss";
import { default as coreDatePickerButtonStyles } from "./core-ui/styles/DatePickerButton.module.scss";
import languageSelectorStyles from "./core-ui/LanguageSelect/styles.module.scss";
import pageLoadingScreenStyles from "./core-ui/styles/PageLoadingScreen.module.scss";

// Core Checkout
import checkoutPageStyles from "./core-ui/styles/CheckoutPage.module.scss";

// Core Self-serve
import supportChatButtonStyles from "./core-self-serve/SupportChatButton/SupportChatButton.module.scss";

// Apac form ui overrides
import phoneNumberFieldStyles from "./apac-form-ui/PhoneNumberField/styles.module.scss";
import textFieldStyles from "./apac-form-ui/TextField/styles.module.scss";

// Fintech ui overrides
import fintechProductStyleOverrides from "./fintech-ui/FintechProduct/styles.module.scss";
import fintechProductBulletStyleOverrides from "./fintech-ui/FintechProductBullet/styles.module.scss";
import fintechProductOptionsSectionStyleOverrides from "./fintech-ui/FintechProductOptionsSection/styles.module.scss";
import fintechProductInfoLinksSectionStyleOverrides from "./fintech-ui/FintechProductInfoLinksSection/styles.module.scss";
import fintechMarketplaceSectionStyleOverrides from "./fintech-ui/FintechMarketplaceSection/styles.module.scss";

export const portalStyleOverrides = {
  [CORE_TRIPS_NAME]: {
    [CoreTripsComponent.TripListLoadingScreen]: tripsLoadingScreenStyles,
    [CoreTripsComponent.TripsCard]: tripsCardStyles,
    [CoreTripsComponent.TripsList]: tripsListStyles,
  },
  [CORE_UI_NAME]: {
    [CoreUiComponents.Page]: pageOverrideStyles,
    [CoreUiComponents.PageHeader]: pageHeaderOverrideStyles,
    [CoreUiComponents.FilterDialogContainer]: filterDialogStyles,
    [CoreUiComponents.NotificationBanner]: notificationBannerStyles,
    [CoreUiComponents.Dialog]: dialogStyles,
    [CoreUiComponents.IframeDialog]: iframeDialogStyles,
    [CoreUiComponents.InfoBanner]: infoBannerStyles,
    [CoreUiComponents.Drawer]: drawerStyles,
    [CoreUiComponents.DatePickerButton]: coreDatePickerButtonStyles,
    [CoreUiComponents.Pill]: pillStyles,
    [CoreUiComponents.InputContainer]: inputContainerStyles,
    [CoreUiComponents.LocationAutocomplete]: locationAutoCompleteStyles,
    [CoreUiComponents.LanguageSelector]: languageSelectorStyles,
    [CoreUiComponents.PageLoadingScreen]: pageLoadingScreenStyles,
  },
  [CORE_CHECKOUT_NAME]: {
    [CoreCheckoutComponent.CheckoutPage]: checkoutPageStyles,
  },
  [APAC_FORM_UI_NAME]: {
    [ApacFormUiComponent.TextField]: textFieldStyles,
    [ApacFormUiComponent.PhoneNumberField]: phoneNumberFieldStyles,
  },
  [CORE_FINTECH_UI_NAME]: {
    [CoreFintechUiComponents.FintechProduct]: fintechProductStyleOverrides,
    [CoreFintechUiComponents.FintechProductBullet]:
      fintechProductBulletStyleOverrides,
    [CoreFintechUiComponents.FintechProductOptionsSection]:
      fintechProductOptionsSectionStyleOverrides,
    [CoreFintechUiComponents.FintechProductInfoLinksSection]:
      fintechProductInfoLinksSectionStyleOverrides,
    [CoreFintechUiComponents.FintechMarketplaceSection]:
      fintechMarketplaceSectionStyleOverrides,
  },
  [CORE_SELF_SERVE_NAME]: {
    [CoreSelfServeComponent.SupportChatButton]: supportChatButtonStyles,
  },
  [APAC_CHECKOUT_NAME]: {
    [ApacCheckoutComponent.CreditCardPayment]: creditCardPaymentStyles,
    [ApacCheckoutComponent.PassengerRow]: passengerRowStyles,
  },
  [APAC_UI_NAME]: {
    [ApacUiComponent.TravelerCards]: travelCardsStyles,
    [ApacUiComponent.LocationAutoCompleteWithSuggestion]:
      locationAutocompleteSuggestionStyles,
  },
};
